import { useFormikContext } from 'formik';
import React, { useEffect } from 'react';

interface AutoSetInputFieldProps {
  dependantKey: string;
  controlKey: string;
  dependantValueComputeFn?: (dependantKey: string) => any;
}

const AutoSetDependantInputField: React.FC<AutoSetInputFieldProps> = ({
  dependantKey,
  controlKey,
  dependantValueComputeFn,
}) => {
  const { setFieldValue, setFieldTouched, values } = useFormikContext<any>();

  useEffect(() => {
    const dependantValue = dependantValueComputeFn?.(values[controlKey]);
    setFieldValue(dependantKey, dependantValue);
    setFieldTouched(dependantKey, true);

    // eslint-disable-next-line
  }, [values[controlKey]]);

  return <></>;
};

export default AutoSetDependantInputField;
